import { Grid } from "@mui/material";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { BreachSearch } from "./BreachSearch/BreachSearch";
import { Confirmation } from "./Confirmation/Confirmation";
import { Failed } from "./Failed/Failed";
import { NoMatch } from "./NoMatch/NoMatch";
import { ApplePayProvider } from "./BreachSearch/components/ApplePayButton/contexts/ApplePay/ApplePayContext";
import { GooglePayProvider } from "./BreachSearch/components/GooglePayButton/contexts/GooglePayContext";
import { Navbar } from "./shared/components/Navbar/Navbar";
import "./App.css";

function App() {
  return (
    <>
      <Navbar />
      <div className="app-content">
        <Grid container>
          <Grid item xs={2} />
          <Grid item xs={8}>
            <Switch>
              <Route exact path="/">
                <GooglePayProvider>
                  <ApplePayProvider>
                    <BreachSearch />
                  </ApplePayProvider>
                </GooglePayProvider>
              </Route>
              <Route exact path="/confirmation/:ticketNbr/:vrm">
                <div className="page-content">
                  <Confirmation />
                </div>
              </Route>
              <Route exact path="/failed">
                <div className="page-content">
                  <Failed />
                </div>
              </Route>
              <Route path="*">
                <div className="page-content">
                  <NoMatch />
                </div>
              </Route>
            </Switch>
          </Grid>
          <Grid item xs={2} />
        </Grid>
      </div>
    </>
  );
}

export default App;
